'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $stateParams, $state) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
  }

  $onInit() {
    this.getDict(this.$stateParams.id);
  }

  getDict(id) {
    this.$http.get(`/api/1/dictionary/${id}/show`).then(response => {
      this.dict = response.data;
    });
  }

  updateDict(dict) {
    this.$http.put('/api/1/dictionary/' + dict._id, this.dict).then(response => {
      this.$state.go('dictionaries.list');
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/dictionaries/edit/edit.controller.js